<div *ngFor="let s of sizes" class="{{(prefix + s.name) }}"></div>